/* ─── Yester Co Theme JS ────────────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav toggle ──────────────────────────────────────────────────────
  const hamburger = document.querySelector('.yc-header__hamburger');
  const mobileNav = document.querySelector('.yc-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // ── Product gallery ────────────────────────────────────────────────────────
  const mainImg = document.querySelector('.yc-gallery__main');
  const thumbs  = document.querySelectorAll('.yc-gallery__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = thumb.dataset.src || thumb.src;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ── Product tabs ───────────────────────────────────────────────────────────
  const tabBtns   = document.querySelectorAll('.yc-tabs__tab');
  const tabPanels = document.querySelectorAll('.yc-tabs__panel');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      const panel = document.querySelector('.yc-tabs__panel[data-tab="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  // ── FAQ accordion ──────────────────────────────────────────────────────────
  const faqItems = document.querySelectorAll('.yc-faq__item');
  faqItems.forEach(function (item) {
    const btn = item.querySelector('.yc-faq__question');
    if (btn) {
      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    }
  });

  // ── Add-on checkbox + dynamic total ───────────────────────────────────────
  const addonCheckbox = document.getElementById('addon-tray');
  const totalDisplay  = document.getElementById('yc-total-price');
  const ctaPrice      = document.getElementById('yc-cta-price');
  const checkoutBtn   = document.getElementById('yc-checkout-btn');
  const checkoutBtnMobile = document.getElementById('yc-checkout-btn-mobile');

  var BASE_PRICE  = 380;
  var ADDON_PRICE = 69;
  var VARIANT_STAND = '47805046292585';
  var VARIANT_TRAY  = '47805062053993';
  var SHOPIFY_STORE = 'yesterco.myshopify.com';

  function buildCartUrl() {
    var items = [VARIANT_STAND + ':1'];
    if (addonCheckbox && addonCheckbox.checked) {
      items.push(VARIANT_TRAY + ':1');
    }
    return 'https://' + SHOPIFY_STORE + '/cart/' + items.join(',');
  }

  function updateTotal() {
    var total = BASE_PRICE + (addonCheckbox && addonCheckbox.checked ? ADDON_PRICE : 0);
    var formatted = '$' + total;
    if (totalDisplay) totalDisplay.textContent = formatted;
    if (ctaPrice) ctaPrice.textContent = formatted;
    if (checkoutBtn) checkoutBtn.dataset.url = buildCartUrl();
    if (checkoutBtnMobile) checkoutBtnMobile.dataset.url = buildCartUrl();
  }

  if (addonCheckbox) {
    addonCheckbox.addEventListener('change', updateTotal);
    updateTotal();
  }

  function handleCheckout(btn) {
    var url = btn.dataset.url || buildCartUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () { handleCheckout(this); });
  }
  if (checkoutBtnMobile) {
    checkoutBtnMobile.addEventListener('click', function () { handleCheckout(this); });
  }

  // ── Addon label click ──────────────────────────────────────────────────────
  const addonRow = document.querySelector('.yc-addon');
  if (addonRow && addonCheckbox) {
    addonRow.addEventListener('click', function (e) {
      if (e.target !== addonCheckbox) {
        addonCheckbox.checked = !addonCheckbox.checked;
        addonCheckbox.dispatchEvent(new Event('change'));
      }
    });
  }

});
